import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { FacultyService } from '../../../services';
import { Faculty } from '../../../models';
import { AlertUtils } from '../../../shared';
import { PopupComponent } from '../../popup-component';
import { FACULTY_LIST_MODIFICATION } from '../../../shared/constants';

@Component({
    selector: 'qms-faculty-delete',
    templateUrl: './faculty-delete.component.html'
})
export class FacultyDeleteComponent {
    public model: Faculty;

    constructor(private activeModal: NgbActiveModal,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private facultyService: FacultyService) {
    }

    public clear() {
        this.activeModal.dismiss('cancel');
    }

    public confirmDelete() {
        this.facultyService.delete(this.model.id).subscribe((response) => {
            this.activeModal.close();
            this.eventManager.broadcast({
                name: FACULTY_LIST_MODIFICATION,
                content: 'Deleted',
                modelId: this.model.id
            });
            AlertUtils.notifySuccess(this.eventManager, this.alertService,
                'faculty.deleted', { param: this.model.name });
        });
    }
}

@Component({
    selector: 'qms-faculty-delete-popup',
    template: ''
})
export class FacultyDeletePopupComponent extends PopupComponent<Faculty, FacultyService> {
    constructor(router: Router,
                route: ActivatedRoute,
                modalService: NgbModal,
                eventManager: JhiEventManager,
                alertService: JhiAlertService,
                facultyService: FacultyService) {
        super(router, route, modalService, eventManager, alertService, facultyService);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/faculties/faculty-delete.component.ts